import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from './MaterialIcon';
import navigationService from '../services/navigationService';
import './MainNavigation.css';

const MainNavigation = ({ currentPage = 'home', compact = false }) => {
  
  const handleNavigation = (path, pageName) => {
    // Use navigation service for client-side routing
    navigationService.navigate(path, pageName);
  };

  const navItems = [
    {
      id: 'home',
      label: 'Home',
      path: '/',
      icon: 'room_preferences'
    },
    {
      id: 'scene-builder',
      label: 'Scene Builder',
      path: '/scene-builder', 
      icon: 'manufacturing'
    },
    {
      id: 'faq',
      label: 'FAQ',
      path: '/faq',
      icon: 'psychology'
    }
  ];

  return (
    <nav className={`main-navigation ${compact ? 'compact' : ''}`} role="navigation" aria-label="Main navigation">
      <div className="nav-container">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleNavigation(item.path, item.id)}
            className={`nav-item nav-item-${item.id} ${currentPage === item.id ? 'active' : ''}`}
            aria-current={currentPage === item.id ? 'page' : undefined}
            title={item.label}
          >
            {item.id === 'scene-builder' ? (
              <div className="nav-gear-icon">
                <img 
                  src="/assets/svgs/clothedEye-loader-spin.svg" 
                  alt="" 
                  className="nav-gear nav-gear-1"
                />
                <img 
                  src="/assets/svgs/clothedEye-loader-static.svg" 
                  alt="" 
                  className="nav-gear nav-gear-static"
                />
                <img 
                  src="/assets/svgs/clothedEye-loader-spin.svg" 
                  alt="" 
                  className="nav-gear nav-gear-2"
                />
              </div>
            ) : (
              <MaterialIcon icon={item.icon} size={20} />
            )}
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

MainNavigation.propTypes = {
  currentPage: PropTypes.string,
  compact: PropTypes.bool
};

export default MainNavigation;
